import { SwapLine } from '@datanomik/core-ui/icons';
export const CashPoolingIcon = SwapLine;
